// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3O0tH","title":"Info_title__aqYIC","selects":"Info_selects__1stvk","requiredAsterisk":"Info_requiredAsterisk__3O1dm"};